import { types, getParent } from 'mobx-state-tree';

import { IsoDate } from '../../../common/v1';

import OptionalIdentifier from '../types/OptionalIdentifier';

import Contact from './Contact';


const ContactPropertyMetadata = types
    .model('ContactPropertyMetadata', {
        id: OptionalIdentifier,
        contact: types.reference(Contact),
        ownProperty: false,
        hasMortgage: false,
        livesAt: false,
        livesWithParents: false,
        currentAddress: false,
        startDate: types.maybe(IsoDate),
        endDate: types.maybe(IsoDate),
    })
    .views(self => ({
        get parentProperty() {
            return getParent(self, 2);
        },
    }));

export default ContactPropertyMetadata;
